import { rem } from '@visiba/std';
import { forwardRef, Ref } from 'react';
import styled from 'styled-components';
import { BaseButton, VisibaCortexBaseButtonProps } from './components_base/base_button.component';
import { Icon, IconType } from './icon.component';

interface Props extends Omit<VisibaCortexBaseButtonProps, 'children'> {
	size?: DesignSystemSourceSizes;
	icon: IconType;
}

function sizeMultiplier(size: DesignSystemSourceSizes): number {
	switch (size) {
		case 'small':
			return 1;
		case 'medium':
			return 1.333333333333333;
		case 'large':
			return 1.666666666666667;
		default:
			return 1;
	}
}

const elements = {
	container: styled(BaseButton)<{ size: DesignSystemSourceSizes }>`
		width: ${({ size }) => rem(24 * sizeMultiplier(size))};
		height: ${({ size }) => rem(24 * sizeMultiplier(size))};
		border-radius: ${({ size }) => rem(6 * sizeMultiplier(size))};
		font-size: ${({ size }) => rem(16 * sizeMultiplier(size))};
		color: #3a3e47;
		display: flex;
		justify-content: center;
		align-items: center;
		transition: background-color 250ms ease;

		&:hover,
		&:focus {
			background-color: color(srgb 0.3011 0.3208 0.365);
		}

		&:active {
			background-color: color(srgb 0.3011 0.3208 0.365);
		}

		&.is-disabled {
			cursor: default;
			color: #afb7c8;
		}
	`,
};

function SquareButton({ icon, size = 'small', ...rest }: Props, ref: Ref<HTMLButtonElement>): JSX.Element {
	return (
		<elements.container {...rest} size={size} ref={ref}>
			<Icon type={icon} />
		</elements.container>
	);
}

const _SquareButton = forwardRef(SquareButton);

export { _SquareButton as SquareButton };
